export class GetGameStartDataError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args: any) {
        super(...args);
        this.name = 'GetGameStartDataError';
    }
}
